import { parseRawAmount } from '../../../../utils/parsing'

/**
 * Withdrawable liquidity for a Compound V2 style market, read from the
 * market's own `getCash()` as the lens publishes it — `totalCash`
 * (Compound/Cream/Venus/Sumer lenses), `cash` (Benqi/Kinetic/Moonwell) or
 * `availableLiquidity` (Tectonic).
 *
 * It must NEVER be derived as `totalDeposits - totalBorrows`. The exchange
 * rate is defined as `(cash + borrows - reserves) / totalSupply`, so
 * `totalDeposits - totalBorrows` collapses algebraically to
 * `cash - totalReserves`: it nets the protocol's reserves out of the
 * user-facing liquidity figure, and turns NEGATIVE on any market whose
 * reserves outgrew its cash. Not hypothetical — Gamma's BNB BUSD market
 * (100 % reserve factor, 38.26 M reserves) reported -41,799,030 against a
 * real `getCash()` of 0.5, and Venus Core's own vTUSDOLD (reserves 3176 % of
 * cash) and vUST (261 %) are negative on mainnet today.
 *
 * Returns `undefined` when the lens published no cash field at all, so the
 * caller can fall back to the derived value rather than advertise a live
 * market as empty.
 */
export const cashLiquidity = (
  raw: string | bigint | number | undefined | null,
  decimals: number,
): number | undefined =>
  raw === undefined || raw === null
    ? undefined
    : Number(parseRawAmount(raw.toString(), decimals))
